import { BlogCategory } from '@/utils/types'

export const BLOG_CATEGORIES = [
  BlogCategory.Engineering,
  BlogCategory.Vitess,
  BlogCategory.Mysql,
  BlogCategory.Neki,
  BlogCategory.Postgres,
  BlogCategory.Product,
  BlogCategory.Tutorials,
  BlogCategory.Company
] as const

export const blogCategoryBySlug = {
  [BlogCategory.Engineering]: {
    label: 'Engineering',
    activeClassName: 'bg-blue-600 text-white hover:text-white dark:bg-blue-500 dark:text-black dark:hover:text-black',
    inactiveClassName: 'text-blue hover:bg-blue-100 dark:hover:bg-blue-900'
  },
  [BlogCategory.Vitess]: {
    label: 'Vitess',
    activeClassName: 'bg-orange-500 text-white hover:text-white dark:text-black dark:hover:text-black',
    inactiveClassName: 'text-orange hover:bg-orange-100 hover:text-orange dark:hover:bg-orange-900'
  },
  [BlogCategory.Mysql]: {
    label: 'MySQL',
    activeClassName: 'bg-mysql text-white hover:text-white dark:text-black dark:hover:text-black',
    inactiveClassName: 'text-mysql hover:bg-gray-100 dark:hover:bg-gray-800'
  },
  [BlogCategory.Neki]: {
    label: 'Neki',
    activeClassName: 'bg-neki text-black hover:text-black dark:bg-neki dark:text-black dark:hover:text-black',
    inactiveClassName: 'text-yellow-600 hover:bg-neki/10 dark:text-neki dark:hover:bg-neki/10'
  },
  [BlogCategory.Postgres]: {
    label: 'PostgreSQL',
    activeClassName: 'bg-postgres text-white hover:text-white dark:text-black dark:hover:text-black',
    inactiveClassName: 'text-postgres hover:bg-gray-100 dark:hover:bg-gray-800'
  },
  [BlogCategory.Product]: {
    label: 'Product',
    activeClassName: 'bg-green-600 text-white hover:text-white dark:bg-green-500 dark:text-black dark:hover:text-black',
    inactiveClassName: 'text-green hover:bg-green-100 hover:text-green dark:hover:bg-green-900'
  },
  [BlogCategory.Tutorials]: {
    label: 'Tutorials',
    activeClassName:
      'bg-purple-600 text-white hover:text-white dark:bg-purple-500 dark:text-black dark:hover:text-black',
    inactiveClassName: 'text-purple hover:bg-purple-100 hover:text-purple dark:hover:bg-purple-900'
  },
  [BlogCategory.Company]: {
    label: 'Company',
    activeClassName: 'bg-red-600 text-white hover:text-white dark:bg-red-500 dark:text-black dark:hover:text-black',
    inactiveClassName: 'text-red hover:bg-red-100 hover:text-red dark:hover:bg-red-900'
  }
} satisfies Record<BlogCategory, { label: string; activeClassName: string; inactiveClassName: string }>

export function formatBlogCategories(categories: BlogCategory[]) {
  return categories.map((category) => blogCategoryBySlug[category].label).join(', ')
}
